'use client';

import { useState } from 'react';

import { CONTEXT_STORAGE_KEY } from '@constants/general';
import { GlobalContext } from '@context/global';
import useSessionStorage from '@hooks/use-session-storage';

//import 'ag-grid-community/styles/ag-grid.css';
//import 'ag-grid-community/styles/ag-theme-alpine.css';
import '@styles/lexical.css';

import './globals.css';

export default function RootLayout({ children }) {
    const { getItem, setItem } = useSessionStorage();
    const storedContext = getItem(CONTEXT_STORAGE_KEY);

    const replacer = function(key, value) {
        if (this[key] instanceof Date) {
            return this[key].toISOString();
        }
        return value;
    }

    const [context, setContext] = useState(storedContext ? JSON.parse(storedContext) : {});
    const setContextValues = (values) => {
        if (values) {
            let cxt = JSON.parse(JSON.stringify(context, replacer));
            values.forEach(v => {
            cxt[v.key] = v.value;
            });
            setContext(cxt);
            setItem(CONTEXT_STORAGE_KEY, JSON.stringify(cxt, replacer));
        }
    };
    
    return (
        <html lang="en">
            <head>
                <title>Seedkit Admin</title>
            </head>
            <body>
                <GlobalContext.Provider value={{ context, setContextValues }}>
                {children}
                </GlobalContext.Provider>
            </body>
        </html>
    );
}
